import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INonWorkingDaysInitialState, INonWorkingDaysPayload } from "../types";
import { GetNonWorkingDays } from "./thunk";

const initialState: INonWorkingDaysInitialState = {
    nonWorkingDays: [],
    isLoadingNonWorkingDays: false,
    selectedNonWorkingDaysIDs: [],
};

const nonWorkingDaysSlice = createSlice({
    name: "nonWorkingDays",
    initialState,
    reducers: {
        setNonWorkingDays: (
            state,
            action: PayloadAction<INonWorkingDaysPayload[]>
        ) => {
            state.nonWorkingDays = action.payload;
        },

        deleteNonWorkingDays: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.nonWorkingDays = state.nonWorkingDays.filter(
                (elem) => elem.id !== id
            );
        },

        updateNonWorkingDays: (
            state,
            action: PayloadAction<{
                updatedNonWorkingDays: INonWorkingDaysPayload;
            }>
        ) => {
            const { updatedNonWorkingDays } = action.payload;
            state.nonWorkingDays = state.nonWorkingDays.map(
                (elem: INonWorkingDaysPayload) => {
                    if (elem.id === updatedNonWorkingDays.id) {
                        return {
                            ...elem,
                            ...updatedNonWorkingDays,
                        };
                    }
                    return elem;
                }
            );
        },

        setSelectedNonWorkingDaysIDs: (
            state,
            action: PayloadAction<number[]>
        ) => {
            state.selectedNonWorkingDaysIDs = action.payload;
        },

        addNonWorkingDays: (
            state,
            action: PayloadAction<INonWorkingDaysPayload[]>
        ) => {
            state.nonWorkingDays.push(...action.payload);
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(GetNonWorkingDays.pending, (state) => {
                state.isLoadingNonWorkingDays = true;
            })
            .addCase(GetNonWorkingDays.fulfilled, (state) => {
                state.isLoadingNonWorkingDays = false;
            })
            .addCase(GetNonWorkingDays.rejected, (state) => {
                state.isLoadingNonWorkingDays = false;
            })
    },
});

export const {
    setNonWorkingDays,
    setSelectedNonWorkingDaysIDs,
    deleteNonWorkingDays,
    updateNonWorkingDays,
    addNonWorkingDays,
} = nonWorkingDaysSlice.actions;

export default nonWorkingDaysSlice;
